"use strict";

var _regeneratorRuntime = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/asyncToGenerator");

var AES_MODE_N = "aes-256-gcm";
var AES_MODE_B = "AES-GCM";
var AES_MODE_BB = {
  name: AES_MODE_B,
  length: 256
};
var isBrowser = typeof window !== 'undefined' && window.crypto;
var wcryp = isBrowser && window.crypto;

var cryp = !isBrowser && require("crypto");

var secureRandom = wcryp ? function (length) {
  return window.crypto.getRandomValues(new Uint8Array(length));
} : function (length) {
  return new Uint8Array(cryp.randomBytes(length).buffer);
};

function hexToArray(hex) {
  if (hex.startsWith('0x')) hex = hex.slice(2);
  if (hex.length & 1) hex = "0".concat(hex);
  var array = new Uint8Array(hex.length / 2);

  for (var i = 0; i < array.length; i++) {
    var j = i * 2;
    array[i] = Number.parseInt(hex.slice(j, j + 2), 16);
  }

  return array;
}
/**
 * @param {Uint8Array} sharedKey
 * @param {Uint8Array|string} plaintext
 * @returns {Promise<Uint8Array>}
 */


function encrypt(_x, _x2) {
  return _encrypt.apply(this, arguments);
}
/**
 * @param {Uint8Array} sharedKey
 * @param {Uint8Array} encoded
 * @returns {Promise<Uint8Array>}
 */


function _encrypt() {
  _encrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(sharedKey, plaintext) {
    var iv, bSharedKey, cipher, ciphertext, encrypted, _cipher, _ciphertext, ciphertextArray, tag, _encrypted;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (typeof plaintext === "string") plaintext = new TextEncoder().encode(plaintext);
            iv = secureRandom(12);

            if (!isBrowser) {
              _context.next = 16;
              break;
            }

            _context.next = 5;
            return wcryp.subtle.importKey("raw", sharedKey, AES_MODE_BB, true, ["encrypt"]);

          case 5:
            bSharedKey = _context.sent;
            _context.next = 8;
            return wcryp.subtle.encrypt({
              name: AES_MODE_B,
              iv: iv
            }, bSharedKey, plaintext);

          case 8:
            cipher = _context.sent;
            ciphertext = new Uint8Array(cipher);
            encrypted = new Uint8Array(iv.length + ciphertext.byteLength);
            encrypted.set(iv, 0);
            encrypted.set(ciphertext, iv.length);
            return _context.abrupt("return", encrypted);

          case 16:
            _cipher = cryp.createCipheriv(AES_MODE_N, sharedKey, iv);
            _ciphertext = _cipher.update(plaintext, undefined, "hex");
            _ciphertext += _cipher.final("hex");
            ciphertextArray = hexToArray(_ciphertext);
            tag = _cipher.getAuthTag();
            _encrypted = new Uint8Array(iv.length + ciphertextArray.length + tag.length);

            _encrypted.set(iv, 0);

            _encrypted.set(ciphertextArray, iv.length);

            _encrypted.set(tag, iv.length + ciphertextArray.length);

            return _context.abrupt("return", _encrypted);

          case 26:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _encrypt.apply(this, arguments);
}

function decrypt(_x3, _x4) {
  return _decrypt.apply(this, arguments);
}
/**
 * Converts a typed array to unicode string in UTF-8 format.
 * @param {Uint8Array} byteArray
 * @returns {string}
 */


function _decrypt() {
  _decrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(sharedKey, encoded) {
    var iv, ciphertextWithTag, bSharedKey, plaintext, ciphertext, authTag, decipher, _plaintext, res;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (typeof encoded === "string") encoded = hexToArray(encoded);
            iv = encoded.slice(0, 12);

            if (!isBrowser) {
              _context2.next = 13;
              break;
            }

            ciphertextWithTag = encoded.slice(12);
            _context2.next = 6;
            return wcryp.subtle.importKey("raw", sharedKey, AES_MODE_BB, true, ["decrypt"]);

          case 6:
            bSharedKey = _context2.sent;
            _context2.next = 9;
            return wcryp.subtle.decrypt({
              name: AES_MODE_B,
              iv: iv
            }, bSharedKey, ciphertextWithTag);

          case 9:
            plaintext = _context2.sent;
            return _context2.abrupt("return", new Uint8Array(plaintext));

          case 13:
            ciphertext = encoded.slice(12, -16);
            authTag = encoded.slice(-16);
            decipher = cryp.createDecipheriv(AES_MODE_N, sharedKey, iv);
            decipher.setAuthTag(authTag);
            _plaintext = decipher.update(ciphertext);
            res = Buffer.concat([_plaintext, decipher.final()]);
            return _context2.abrupt("return", Uint8Array.from(res));

          case 20:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _decrypt.apply(this, arguments);
}

function bytesToUTF8(byteArray) {
  return new TextDecoder().decode(byteArray);
}

if (typeof exports !== "undefined") {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.decrypt = decrypt;
  exports.encrypt = encrypt;
  exports.bytesToUTF8 = bytesToUTF8;
}